import { cx } from "@linaria/core";
import { Exhibit } from "timvir/blocks";
import { useBlock } from "timvir/core";
import * as base58 from "bytestring/base58";
import * as React from "react";
import { useImmer } from "use-immer";
import { Context } from "./context";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentPropsWithRef<typeof Root> {
  ExhibitProps?: React.ComponentPropsWithRef<typeof Exhibit>;
}
function Arbitrary(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const block = useBlock(props);
  const {
    ExhibitProps,
    className,
    children,
    ...rest
  } = block.props;
  const [value, mutate] = useImmer({
    seed: 0
  });
  React.useEffect(() => {
    mutate(draft => {
      draft.seed = crypto.getRandomValues(new Uint32Array(1))[0];
    });
  }, [mutate]);
  React.useEffect(() => {
    if (props.id) {
      block.bus.next({
        type: "SIGNAL",
        path: `/dev/timvir/block/${props.id}`,
        interface: "dev.timvir.block.Arbitrary",
        member: "seed",
        body: value.seed
      });
    }
  }, [block.bus, value.seed]);
  return <Context.Provider value={value}>
      <Root ref={ref} className={cx(classes.root, className)} {...rest}>
        <div className={classes.controls}>
          <div className={classes.textField}>
            <span className={classes.startAdornment}>Seed:</span>
            <input className={classes.input} placeholder="Seed" value={base58.encode(new TextEncoder().encode(`${value.seed}`))} readOnly onPaste={ev => {
            const v = ev.clipboardData.getData("text/plain");
            mutate(draft => {
              draft.seed = +new TextDecoder().decode(base58.decode(v));
            });
          }} onFocus={ev => {
            ev.currentTarget.select();
          }} />
          </div>

          <button className={classes.button} onClick={() => {
          mutate(draft => {
            draft.seed = crypto.getRandomValues(new Uint32Array(1))[0];
          });
        }}>
            Refresh
          </button>
        </div>

        <Exhibit bleed={0} BackdropProps={{
        style: {
          borderRadius: 2,
          border: "1px solid var(--timvir-border-color)"
        }
      }} {...ExhibitProps}>
          {children}
        </Exhibit>
      </Root>
    </Context.Provider>;
}
export default React.forwardRef(Arbitrary);
const classes = {
  root: "r1ev38xg",
  controls: "c8hz158",
  textField: "t1663phv",
  startAdornment: "s1k50njo",
  input: "i1dajnne",
  button: "b128wsn"
};

require("./Arbitrary.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Arbitrary.tsx");